const loaderStyle = theme => ({
    loader: {
        marginLeft: "10px",
        color: "#FFFFFF"
    },
});

export default loaderStyle;
